import _ from "lodash";

import {
  REQUEST_DATA,
  NETWORK_ERROR,
  POST_DATA,
  RECEIVE_DATA,
  CANCEL_REQUEST,
  REQUEST_ERROR
} from "./Actions";

const initialState = {
  sources: {},
  isFetching: false,
  hasError: false
};

function getSourceState(action) {
  switch (action.type) {
    case REQUEST_DATA:
      return {
        isFetching: true,
        source: action.source
      };

    case POST_DATA:
      return {
        isFetching: true,
        isPosted: true,
        postData: action.data,
        source: action.source
      };

    case NETWORK_ERROR:
      return {
        isFetching: false,
        error: action.error,
        source: action.source
      };

    case REQUEST_ERROR:
      console.warn("api request error");
      return {
        isFetching: false,
        hasError: true,
        error: action.error,
        source: action.source
      };

    case RECEIVE_DATA:
      return {
        isFetching: false,
        hasError: false,
        status: action.status,
        data: action.data,
        source: action.source
      };

    case CANCEL_REQUEST:
      return {
        isFetching: false,
        isCancelled: true,
        source: action.source
      };
  }
}

export default function apiReducer(state = initialState, action = {}) {
  switch (action.type) {
    case REQUEST_DATA:
    case POST_DATA:
    case NETWORK_ERROR:
    case RECEIVE_DATA:
    case CANCEL_REQUEST:
    case REQUEST_ERROR:
      const sourceState = getSourceState(action);
      const sources = {
        ...state.sources,
        [action.source]: sourceState
      };
      return {
        ...state,
        sources,
        hasError: sourceState.hasError,
        isFetching: _.reduce(
          sources,
          (result, value) => result || value.isFetching,
          false
        )
      };

    default:
      return state;
  }
}
